import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#3B2A1E] group-[.toaster]:text-[#F2E9D8] group-[.toaster]:border-[#4A3626] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#A79680]",
          actionButton:
            "group-[.toast]:bg-[#A8794A] group-[.toast]:text-[#14100C]",
          cancelButton:
            "group-[.toast]:bg-[#241812] group-[.toast]:text-[#A79680]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast }
